import React from 'react';

const Title = ({ firstName, lastName }) => (
  <div className="allocation-card-title">
    {firstName} {lastName}
  </div>
);

export default Title;
